import { render, staticRenderFns } from "./codeDictModal2.vue?vue&type=template&id=533b202c"
import script from "./codeDictModal2.vue?vue&type=script&lang=js"
export * from "./codeDictModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports